import React, { useState, useImperativeHandle, useEffect, forwardRef } from 'react';
import { useLanguage } from 'Context/LanguageContext';
import TextField from '~/TextField/TextField.component';
import Grid from '@mui/material/Grid2';
import {FielderPhoneField} from '~/FielderElements/FielderElements.component';
import { FIELDER } from '@core/constants/base.constants';
import { Box } from '@mui/material';

const MoreBranchInformation = ({ showMoreBranchInfo, nameValue, lastNameValue,
      emailValue, cellphoneValue, officePhoneValue, commentValue, editData}, ref ) => {
    const lan = useLanguage();
    const { txt: TXT_ID, btn: BTN_ID, dtpckr: DTPCK_ID } = FIELDER.idElement;
    const formatPhoneNumber = (phoneNumber) => {
        const trimmed = phoneNumber.trim();
        const ncell =  trimmed && !trimmed.startsWith("+") ? `+${trimmed}` : trimmed;
        console.log("ncell", ncell);
        return ncell;
    }
	const [name, setName] = useState(nameValue ? nameValue : '');
    const [lastName, setLastName] = useState(lastNameValue ? lastNameValue : '');
    const [email, setEmail] = useState(emailValue ? emailValue : '');
    const [cellphone, setCellPhone] = useState(cellphoneValue ? formatPhoneNumber(cellphoneValue) : '');
    const [officePhone, setOfficePhone] = useState(officePhoneValue ? formatPhoneNumber(officePhoneValue) : '');
    const [comment, setComment] = useState(commentValue ? commentValue : '');
    useEffect(() => {
        if (nameValue) setName(nameValue);
        if (lastNameValue) setLastName(lastNameValue);
        if (emailValue) setEmail(emailValue);
        if (cellphoneValue) setCellPhone( formatPhoneNumber(cellphoneValue));
        if (officePhoneValue) setOfficePhone(formatPhoneNumber(officePhoneValue));
        if (commentValue) setComment(commentValue);
    }, [nameValue, lastNameValue, emailValue, cellphoneValue, officePhoneValue, commentValue]);
    useImperativeHandle(ref, () => ({
        name,
        lastName,
        email,
        cellphone,
        officePhone,
        comment
      }), [name, lastName, email, cellphone, officePhone, comment]);
	const handleChange = ( event, textField) => {
        switch(textField){
            case "name":
                setName(event.target.value);
                break;
            case "lastName":
                setLastName(event.target.value);
                break;
            case "cellPhone":
                setCellPhone(event.target.value);
                break;
            case "officePhone":
                setOfficePhone(event.target.value);
                break;
            case "email":
                setEmail(event.target.value);
                break;
            case "comment":
                setComment(event.target.value);
                break;
            default:
                break;
        }
	};
	return (
    <>
      {showMoreBranchInfo && (
        <Grid container spacing={2}>
          {/* Name / Lastname */}
          <Grid size={{ xs: 12, sm: 6 }}>
            <TextField
              id="txt-task-name"
              value={name}
              variant="outlined"
              label={`${lan.name} (${lan.optional})`}
              onChange={(e) => handleChange(e, 'name')}
              disabled={!editData}
              fullWidth
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <TextField
              id="txt-task-lastName"
              value={lastName}
              variant="outlined"
              label={`${lan.lastName} (${lan.optional})`}
              onChange={(e) => handleChange(e, 'lastName')}
              disabled={!editData}
              fullWidth
            />
          </Grid>
          {/* Phones */}
          <Grid size={{ xs: 12, sm: 6 }}>
            <FielderPhoneField
              id={TXT_ID.phone}
              label={lan.cellphoneClient}
              value={cellphone}
              onChange={(value) => {
                const v = value === undefined ? '' : value;
                setCellPhone(v);
              }}
              lan={lan}
              disabled={!editData}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <FielderPhoneField
              id={TXT_ID.mobile}
              label={lan.officePhone}
              value={officePhone}
              onChange={(value) => {
                const v = value === undefined ? '' : value;
                setOfficePhone(v);
              }}
              lan={lan}
              disabled={!editData}
            />
          </Grid>
          {/* Email */}
          <Grid size={{ xs: 12, sm: 6 }}>
            <TextField
              id="txt-email"
              value={email}
              variant="outlined"
              label={`${lan.email} (${lan.optional})`}
              onChange={(e) => handleChange(e, 'email')}
              disabled={!editData}
              fullWidth
            />
          </Grid>
          {/* Comment label */}
          <Grid size={12}>
            <Box sx={{ mt: 1 }}>
              {lan.comment}
            </Box>
          </Grid>
          {/* Comment textarea */}
          <Grid size={12}>
            <TextField
              id="legalAddress-input"
              label={lan.comment}
              value={comment}
              onChange={(e) => handleChange(e, 'comment')}
              multiline
              rows={3}
              fullWidth
              variant="outlined"
              sx={{
                '& .MuiInputBase-root': {
                  paddingTop: '5px',
                  paddingLeft: '10px',
                  paddingBottom: '5px',
                  paddingRight: '10px',
                },
              }}
              disabled={!editData}
            />
          </Grid>
        </Grid>
      )}
    </>
	);
};
export default forwardRef(MoreBranchInformation);
